jQuery(document).ready(function($){
	//if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), don't forget to update this value as well
	var $L = 1200,
		$menu_navigation = $('#main-nav'),
		$cart_trigger = $('.cd-cart-trigger'),
        //$cart_trigger = $('.site-header__cart'),
		$hamburger_icon = $('#cd-hamburger-menu'),
		$lateral_cart = $('#cd-cart'),
		$shadow_layer = $('#cd-shadow-layer'),
  		$cd__close = $('.cd__close_2');



	//open lateral menu on mobile
	$hamburger_icon.on('click', function(event){
		event.preventDefault();
		//close cart panel (if it's open)
		$lateral_cart.removeClass('speed-in');
		toggle_panel_visibility($lateral_cart, $shadow_layer, $('body'));
	});

	//open cart
	$cart_trigger.on('click', function(event){
		event.preventDefault();
		//close lateral menu (if it's open)
		$menu_navigation.removeClass('speed-in');


		toggle_panel_visibility($lateral_cart, $shadow_layer, $('body'));
	});

	//close lateral cart or lateral menu
	$shadow_layer.on('click', function(){
		$shadow_layer.removeClass('is-visible');
		// firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
		if( $lateral_cart.hasClass('speed-in') ) {
			$lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
				$('body').removeClass('overflow-hidden');
			});
			$menu_navigation.removeClass('speed-in');
		} else {
			$menu_navigation.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
				$('body').removeClass('overflow-hidden');
			});
			$lateral_cart.removeClass('speed-in');
		}
	});


    $cd__close.on('click', function(){
		$shadow_layer.removeClass('is-visible');
		// firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
		if( $lateral_cart.hasClass('speed-in') ) {
			$lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
				$('body').removeClass('overflow-hidden');
			});
			$menu_navigation.removeClass('speed-in');
		} else {
			$menu_navigation.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
				$('body').removeClass('overflow-hidden');
			});
			$lateral_cart.removeClass('speed-in');
		}
	});

	//move #main-navigation inside header on laptop
	//insert #main-navigation after header on mobile
	move_navigation( $menu_navigation, $L);
	$(window).on('resize', function(){
		move_navigation( $menu_navigation, $L);

		if( $(window).width() >= $L && $menu_navigation.hasClass('speed-in')) {
			$menu_navigation.removeClass('speed-in');
			$shadow_layer.removeClass('is-visible');
			$('body').removeClass('overflow-hidden');
		}

	});

});

function toggle_panel_visibility ($lateral_panel, $background_layer, $body) {
	if( $lateral_panel.hasClass('speed-in') ) {
		// firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
		$lateral_panel.removeClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
			$body.removeClass('overflow-hidden');
		});
		$background_layer.removeClass('is-visible');

	} else {
		$lateral_panel.addClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
			$body.addClass('overflow-hidden');
		});
		$background_layer.addClass('is-visible');
	}
}

function move_navigation( $navigation, $MQ) {
	if ( $(window).width() >= $MQ ) {
		$navigation.detach();
		$navigation.appendTo('header');
	} else {
		$navigation.detach();
		$navigation.insertAfter('header');
	}
}

function fetchCart(cart) {
    
}


function renderCart(cart) {
    //alert();
    /*
    console.log('----------------hello----------------------------------');
    console.log(cart);
    console.log('--------------------------------------------------');
    */

    $('#cd-cart .checkout-btn').off('click')

    let rackItems = [];
    let rackAssortments = {}
    let seedPacketCount = 0;
    let requiredPacketCount = 0
    let requiredPacketObject = {
        'renees-garden': {
            required: 0,
            seeds: 0
        },
        'cornucopia-seeds': {
            required: 0,
            seeds: 0
        }
    }

    var c_prod_data = '';
    cart.items.forEach(function(item, index) {
        if ( item.properties && item.properties._rack_assortment ) {
            rackAssortments[item.properties._rack_assortment] = rackAssortments[item.properties._rack_assortment] ? rackAssortments[item.properties._rack_assortment] + item.quantity : item.quantity
        } 
        if ( item.properties && item.properties._rack_count ) {
            console.log('rack count', item.properties._rack_count)
            requiredPacketCount += item.properties._rack_count * item.quantity
            requiredPacketObject[item.properties._rack_type].required += item.properties._rack_count * item.quantity
        }
        if ( item.product_type !== 'Wholesale Display' && item.product_type !== 'Assortment' ) {
            seedPacketCount += item.quantity
            if ( item.properties && item.properties._seed_vendor && item.properties._seed_vendor.seeds ) {
                requiredPacketObject[item.properties._seed_vendor].seeds += item.quantity
            }
        }
    })

    const cartItems = cart.items.map ( item => {
        if ( item.properties && item.properties._rack_count ) {
            item.inventory_needed = item.properties._rack_count * item.quantity
            if ( rackAssortments[item.variant_id] !== undefined ) {
                item.inventory_needed = (item.properties._rack_count * item.quantity) - (rackAssortments[item.variant_id] * item.properties._rack_count)
                requiredPacketCount -= item.properties._rack_count * rackAssortments[item.variant_id]
                requiredPacketObject[item.properties._rack_type].required -= item.properties._rack_count * rackAssortments[item.variant_id]
            }
            rackItems.push(item)
        }
        return item
    })

    // console.log(seedPacketCount, requiredPacketCount)
    $('#cd-cart-rack-alert').css('margin-bottom', '0').html('')
    if ( seedPacketCount < requiredPacketCount ) {
        Object.keys(requiredPacketObject).forEach( key => {
            console.log('key', key)
            if ( requiredPacketObject[key].required > requiredPacketObject[key].seeds ) {
                const wholesaleUrl = key === 'renees-garden' ? '/pages/wholesale-reorder-renees' : '/pages/wholesale-reorder-cornucopia'
                const wholesaleType = key === 'renees-garden' ? 'Renee\s Garden' : 'Cornucopia'
                $('#cd-cart-rack-alert').css('margin-bottom', '1rem').append(`<p aria-alert style="display: block; font-size: .7em; margin-bottom: 0;" class="alert text-center">*${ requiredPacketObject[key].required - requiredPacketObject[key].seeds } additional <b>${wholesaleType}</b> seed packets required. <a style="font-size: 1em; text-decoration: underline; font-weight: bold;" href="${wholesaleUrl}">Order your seed packets here.</a></p>`)
                if ($('#cart-page-rack-alert').length > 0) {
                    $('#cart-page-rack-alert').css('margin-top', '1rem').prepend(`<p aria-alert style="display: block; font-size: .7em; margin-bottom: 0;" class="alert">*${ requiredPacketObject[key].required - requiredPacketObject[key].seeds } additional <b>${wholesaleType}</b> seed packets required. <a style="font-size: 1em; text-decoration: underline; font-weight: bold;" href="${wholesaleUrl}">Order your seed packets here.</a></p>`)
                }
            }   
        })
        $('#cd-cart .checkout-btn, .cart-buttons #checkout').on('click', function(e) {
            e.preventDefault();
            let alertString = ''
            Object.keys(requiredPacketObject).forEach( key => {
                console.log('key', key)
                if ( requiredPacketObject[key].required > requiredPacketObject[key].seeds ) {
                    const wholesaleType = key === 'renees-garden' ? 'Renee\s Garden' : 'Cornucopia'
                    alertString += `*${ requiredPacketObject[key].required - requiredPacketObject[key].seeds } additional ${wholesaleType} seed packets required.\n`
                }
            })
            alert(alertString);
        })
    } else {
        $('#cd-cart-rack-alert').css('margin-bottom', '0').html('');
        if ($('#cart-page-rack-alert').length > 0) {
         $('#cart-page-rack-alert').css('margin-bottom', '0').html('');
        }
    }

    cartItems.forEach(function(item, index) {
        console.log(item)
        let wholesaleTitle = item.title;
        if ( item.properties && item.properties._wholesale_title ) {
            wholesaleTitle = item.properties._wholesale_title;
            if (wholesaleTitle == null || wholesaleTitle == undefined || wholesaleTitle == '') {
                wholesaleTitle = item.title;
            }
        }
        const quantityClass = item.quantity > 99 ? ' large-qty' : '';
        if ( item.product_type !== 'Wholesale Display' && item.product_type !== 'Assortment' ) {
            var qty_box='<div class="mm_quantity mm_buttons_added" data-qid="' + item.key + '" data-qline="' + Number(index + 1) + '" data-cdcq="'+item.quantity+'"><input type="button" value="-" class="minus"><input type="text" step="6" min="0" name="quantity" value="'+item.quantity+'" title="Qty" class="input-text qty text cd_qty' + quantityClass + '" size="4" pattern="" inputmode=""><input type="button" value="+" class="plus"></div>';
        } else {
            var qty_box='<div class="mm_quantity mm_buttons_added" data-qid="' + item.key + '" data-qline="' + Number(index + 1) + '" data-cdcq="'+item.quantity+'"><input type="button" value="-" class="minus"><input type="text" step="1" min="0" name="quantity" value="'+item.quantity+'" title="Qty" class="input-text qty text cd_qty' + quantityClass + '" size="4" pattern="" inputmode=""><input type="button" value="+" class="plus"></div>';
        }
        var productImage = '<img style="width:60px; height:auto;" class="ajax-cart-item__image" src="' + item.image + '" >';
        c_prod_data += '<li data-id="' + item.key + '" class="cd_row_' + Number(index + 1) + '"><div class="sc_t"><div class="sc_td sc_td_1">'+productImage+'</div><div class="sc_td sc_td_2"><span class="cd-title"><a href="' + "#" + '"> ' + wholesaleTitle + '</a></span>';
        // If the requirement object has more required than seeds AND inventory_needed is populated, show the alert
        if ( item.inventory_needed && requiredPacketObject[item.properties._rack_type].required > requiredPacketObject[item.properties._rack_type].seeds ) {
            let wholesaleUrl = item.properties._rack_type === 'renees-garden' ? '/pages/wholesale-reorder-renees' : '/pages/wholesale-reorder-cornucopia'
            c_prod_data += `<sub style="display: block; margin-bottom: 0;">* Requires additional seed packs<span style="display: block; margin-top: .25rem; margin-left: 1rem;"><a style="font-size: 1em; text-decoration: underline; font-weight: bold;" href="${wholesaleUrl}">Order your seed packets here.</a></span></sub>`
            console.log("packs required for item with key: " + item.key);
            if ($('#cart-page-rack-alert').length > 0) {
                $(`.order-summary-table .item[data-key='${item.key}']`).append(`<sub style="display: block; margin-bottom: 0;">* Requires additional seed packs<span style="display: block; margin-top: .25rem; margin-left: 1rem;"><a style="font-size: 1em; text-decoration: underline; font-weight: bold;" href="${wholesaleUrl}">Order your seed packets here.</a></span></sub>`)
            }
        }

        //c_prod_data += '<div class="cd-price">'+Shopify.formatMoney(item.line_price)+'</div></div><div class="sc_td sc_td_3">'+qty_box+'<br><a onclick="cd_remove_item(' + Number(index + 1) + ');" class="cd__close- cd__close_1">Remove</a></div></div></li>'
        c_prod_data += '</div><div class="sc_td sc_td_3">'+qty_box+'<br><a onclick="cd_remove_item(' + Number(index + 1) + ');" class="cd__close- cd__close_1">Remove</a></div></div></li>'

    });

    $('.cd-cart-items').html(c_prod_data);  
    $('.cd-cart-total p span').html(Shopify.formatMoney(cart.total_price));
    $('.cd_count').val(cart.item_count);

    const qtySels = document.querySelectorAll('.cd_qty')
    qtySels.forEach( qtySel => {
        qtySel.onchange = function (e) {
            console.log('hi',this.value);
            roundToStep(this);
        }
    })

    if ( typeof(populateWholesaleForm) !== 'undefined' ) populateWholesaleForm(cart, false)

    function roundToStep(e) {
        let step = e.step;
        console.log('step: ', step);
        let newQuant = step*Math.ceil(e.value/step);
        console.log(newQuant);
        e.value = newQuant;
        var qid=jQuery(e).parent().attr('data-qid');
        var qline=jQuery(e).parent().attr('data-qline');
        console.log(qid);
        console.log(qline);
        changeItem(qid, newQuant, qline);
        // changeItem()
    }

    // Determine if cart is empty
    if (cart.item_count === 0) {

        $('.checkout-btn').hide();
        $('.cd-go-to-cart').hide();
        $('.cd-cart-total').hide();
        $('.cd-cart-items').html('<div class="cd_empty">Cart is empty</div>');
      } else {
        $('.checkout-btn').show();
        $('.cd-go-to-cart').show();
        $('.cd-cart-total').show();
      }
}

document.addEventListener('DOMContentLoaded', function() {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            renderCart(cart)
        },
    });
});



  validateQty = function(qty) {
    if (parseFloat(qty) === parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };


function cd_remove_item(line){
  var cd_qty = 0;
  var c_item_id = $('.cd_row_'+line).attr("data-id");
  changeItem(c_item_id, cd_qty, line);
}

/*function cd_update_item(line){
  var cd_qty = validateQty($('.cd_row_'+line).find(".cd_qty").val());
  var c_item_id = $('.cd_row_'+line).attr("data-id");
  changeItem(c_item_id, cd_qty, line);
}*/

function changeItem(c_item_id, quantity, line, callback) {
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&id=' + c_item_id,
        //data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {                
                renderCart(cart)
              //   if(quantity==0){
              //     $('.cd_row_'+line).remove();                
              //   }
              //   $('.cd-cart-total p span').html(Shopify.formatMoney(cart.total_price));
              //   if(cart.item_count==0){
              //     $('.c_count').html('');
              //     $('.checkout-btn').hide();
              //     $('.cd-go-to-cart').hide();
              //     $('.cd-cart-total').hide();
              //     $('.cd-cart-items').html('<div class="cd_empty">Cart is empty</div>');
              //   }else{
              //   	$('.c_count').html(' ('+cart.item_count+')');
              //   }  
                
              //   if(cart.item_count==$('.cd_count').val()){
              //     var oq = $('.cd_row_'+line).find('.mm_quantity').attr('data-cdcq');
              //     $('.cd_row_'+line).find('.mm_quantity .cd_qty').val(oq);
              //     //alert(oq);                
              //   }else{
              //     $('.cd_count').val(cart.item_count);
              //     $('.cd_row_'+line).find('.mm_quantity').attr('data-cdcq' , quantity);
              //   }
                
              }
        },
    });
}


/*qty box*/
function mm_refresh_quantity_increments() {
    jQuery("div.mm_quantity:not(.mm_buttons_added), td.mm_quantity:not(.mm_buttons_added)").each(function(a, b) {
        var c = jQuery(b);
        c.addClass("mm_buttons_added"), c.children().first().before('<input type="button" value="-" class="minus" />'), c.children().last().after('<input type="button" value="+" class="plus" />')
    })
}
String.prototype.getDecimals || (String.prototype.getDecimals = function() {
    var a = this,
        b = ("" + a).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    return b ? Math.max(0, (b[1] ? b[1].length : 0) - (b[2] ? +b[2] : 0)) : 0
}), jQuery(document).ready(function() {
    mm_refresh_quantity_increments()
}), jQuery(document).on("updated_wc_div", function() {
    mm_refresh_quantity_increments()
}), jQuery(document).on("click", ".plus, .minus", function() {
    var a = jQuery(this).closest(".mm_quantity").find(".qty"),
        b = parseFloat(a.val()),
        c = parseFloat(a.attr("max")),
        d = parseFloat(a.attr("min")),
        e = a.attr("step");
    b && "" !== b && "NaN" !== b || (b = 0), "" !== c && "NaN" !== c || (c = ""), "" !== d && "NaN" !== d || (d = 0), "any" !== e && "" !== e && void 0 !== e && "NaN" !== parseFloat(e) || (e = 1), jQuery(this).is(".plus") ? c && b >= c ? a.val(c) : a.val((b + parseFloat(e)).toFixed(e.getDecimals())) : d && b <= d ? a.val(d) : b > 0 && a.val((b - parseFloat(e)).toFixed(e.getDecimals())), a.trigger("change")

    var qid=jQuery(this).parent().attr('data-qid');
    var qline=jQuery(this).parent().attr('data-qline');
    var cdcq=jQuery(this).parent().attr('data-cdcq');

    changeItem(qid, a.val(), qline);

});

//Get wholesale title metafields
function fetchWholesaleTitles() {
    const productQuery = () => `
        query {
        product(handle: "lettuce-bibb-organic-pattys-choice") {
        wholesaletitle: metafield(namespace: "wholesale", key: "product_title") {
            value
            type
        }
        }
        }
    `;
    const STOREFRONT_ACCESS_TOKEN =  '1a75f205f24964d945ce562280adaab6';
    const GRAPHQL_URL = 'https://renees-garden-testing-store.myshopify.com/api/2020-07/graphql.json';
    const GRAPHQL_BODY  = () => {
        return {
        'async': true,
        'crossDomain': true,
        'method': 'POST',
        'headers': {
            'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
            'Content-Type': 'application/graphql',
        },
        'body': productQuery()
        };
    }
    fetch(GRAPHQL_URL, GRAPHQL_BODY())
        .then(res => res.json())
	.then(products => {
		console.log('products', products)
	})
}
